<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="选择规则值"
    v-bind="$attrs"
    :destroy-on-close="true"
  >
    <div class="dialog-around h-60">
      <!-- 组织树 -->
      <rc-tree
        ref="rcTree"
        class="w-6/12"
        :title="'部门树'"
        :show-checkbox="true"
        :show-strictly="true"
        :multi="multi"
        :tree-data="treeData"
        :default-checked-keys="defaultCheckedKeys"
        :default-expanded-keys="defaultExpandedKeys"
        :props="treeProps"
        :current-node-key="currentNodeKey"
        @node-click="handleNodeClick"
        @treeCheckChange="treeCheckChange"
      ></rc-tree>
      <div class="w-1/12 flex flex-col justify-around items-center text-xl">
        <i class="el-icon-arrow-left"></i>
        <i class="el-icon-arrow-right"></i>
      </div>
      <!-- 用户已选择 -->
      <rc-object-selected
        class="w-6/12"
        :data="selectList"
        @clearAllSelect="clearAllSelect"
        @deleteSelect="deleteSelect"
      ></rc-object-selected>
    </div>

    <span slot="footer" class="text-right">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="changeRuleValue">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import RcTree from "@/views/standard/business/components/RcTree";
import RcObjectSelected from "@/views/standard/business/components//RcObjectSelected";
import userApi from "@/api/user/user";
import { $isEmptyObject } from "@/utils/components/helper";

export default {
  name: "MetaOrgDialog",
  components: { RcTree, RcObjectSelected },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectItemRule: {
      type: Object,
      default: () => {}
    },
    multi: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      // 左边树
      currentNodeKey: undefined,
      treeProps: { label: "orgName" },
      treeData: [],
      defaultExpandedKeys: [],
      defaultCheckedKeys: [],
      // 已选择的
      selectList: [],
      lock: false
    };
  },
  computed: {
    ...mapGetters(["tenantId"]),
    checkedKeys() {
      return this.selectList.map(item => item.id);
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val;
        val && this.initData();
      }
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    }
  },
  methods: {
    initData() {
      // 初始化树
      this.initTree();

      // 初始化已选择list
      this.initObjectSelected();
    },
    async initTree() {
      const params = { parseToTree: true };
      const { data } = await userApi.getOrgList(this.tenantId, params).catch(() => {});
      // 过滤掉当前组织
      this.treeData = [data];
      this.defaultExpandedKeys = [data.id];
      this.currentNodeKey = data.id;
    },
    // 树节点点击
    handleNodeClick(node) {
      const { id } = node;
      this.currentNodeKey = id;
    },
    // 树节点选中
    treeCheckChange({ checkedNodes, halfCheckedNodes }) {
      const nodes = [...checkedNodes, ...halfCheckedNodes];
      this.selectList = nodes.map(node => ({ id: node.id, name: node.orgName }));
    },
    initObjectSelected() {
      if ($isEmptyObject(this.selectItemRule) || !this.selectItemRule) {
        this.defaultCheckedKeys = [];
        this.selectList = [];
        return;
      }

      const { value: selectIds, fieldDesc: { showValueString: selectNames }} = this.selectItemRule;

      if (!selectIds || !selectNames) {
        this.defaultCheckedKeys = [];
        this.selectList = [];
        return;
      }

      // 处理默认选中的值
      const ids = selectIds.split(",");
      const names = selectNames.split(",");

      // 赋值左侧选中的树节点
      this.defaultCheckedKeys = ids;

      ids.forEach((id, index) => {
        this.selectList.push({ id, name: names[index] });
      });
    },
    clearAllSelect() {
      this.$refs.rcTree.clearSelected();
    },
    deleteSelect({ id }) {
      this.$refs.rcTree.setChecked(id, false, true);
    },
    changeRuleValue() {
      // 处理数据
      const result = this.selectList.reduce((acc, cur) => {
        acc.value += `${cur.id},`;
        acc.showValueString += `${cur.name},`;
        return acc;
      }, { value: "", showValueString: "" });

      // 去除尾部逗号
      const reg = /,$/gi;
      const value = result.value.replace(reg, "");
      const showValueString = result.showValueString.replace(reg, "");

      // 广播数据
      this.$emit("changeRuleValue", { value, showValueString, selectList: this.selectList });

      // 关闭弹框
      this.dialogVisible = false;
    }
  }
};
</script>
